import React from "react";
import { CopyActionValidationStatus } from "./sidebar-toolbar-types";
import { useCopyLayerTooltip } from "./hooks/use-copy-layer-tooltip";

export const DisabledCopyMessage = ({ status }: { status: CopyActionValidationStatus }) => {
    const tooltipMessage = useCopyLayerTooltip(status);
    return (
        <div>
            <span>{tooltipMessage}</span>
        </div>
    );
};
